<!-- 上下限设置 -->
<template>
    <div class="warehouseOut" v-loading="loading">
        <div class="warehouseOut-main">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 30%">仓库</div>
                <div class="div-table-cell" style="width: 70%">锁定仓位</div>
            </div>
            <div class="table-main">
                <div class="div-table-row" v-for="(wh, index) in warehouseList" :key="wh.WarehouseId">
                    <div class="div-table-cell" style="width: 30%">
                        {{ wh.WarehouseName }}
                    </div>
                    <div class="div-table-cell" style="width: 70%">
                        <el-select
                            v-model="wh.SelectedValues"
                            multiple
                            :multiple-limit="10"
                            filterable
                            remote
                            size="small"
                            style="width: 100%"
                            reserve-keyword
                            placeholder="请输入仓位码"
                            @change="positionChange($event, index)"
                            :remote-method="val => remoteMethod(val, wh.WarehouseId, wh)"
                            @visible-change="positionVisibleChange($event, wh.WarehouseId, wh)"
                        >
                            <el-option
                                v-for="optionItem in wh.ShelfSpacesList"
                                :label="optionItem.ShelfSpaceCode"
                                :value="optionItem.ShelfSpaceId"
                                v-bind:key="optionItem.ShelfSpaceId"
                            >
                                <span style="display: inline-block; width: 150px">{{ optionItem.ShelfSpaceCode }}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button class="btn-primary" size="small" @click="comfirm">确定</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['GoodsId', 'IsSave'],
    components: {},
    data() {
        return {
            Limit: 10,
            loading: false,
            warehouseList: [],
            dataList: [],
            searchPositionReq: {
                WarehouseId: '',
                ShelfSpaceCode: '',
                Page: 1,
                Limit: 10
            }
        };
    },
    mounted() {
        let that = this;

        if (!this.GoodsId) {
            this.$util.warningMsg('商品数据异常，请刷新后重新操作');
            return;
        }

        //获取仓库列表
        that.getWarehouse();
    },
    methods: {
        getWarehouse() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsLockSpaces',
                    data: { GoodsId: that.GoodsId },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.warehouseList = data;

                    for (let index = 0; index < that.warehouseList.length; index++) {
                        const element = that.warehouseList[index];
                        let sIds = [];
                        if (that.warehouseList[index].ShelfSpacesList && that.warehouseList[index].ShelfSpacesList.length > 0) {
                            for (let j = 0; j < that.warehouseList[index].ShelfSpacesList.length; j++) {
                                const s = that.warehouseList[index].ShelfSpacesList[j];
                                sIds.push(s.ShelfSpaceId);
                            }
                        }
                        that.warehouseList[index].SelectedValues = sIds;
                        let item = {
                            WarehouseId: element.WarehouseId,
                            SpacesIds: sIds
                        };
                        that.dataList.push(item);
                    }
                })
                .catch(() => {})
                .finally(() => {
                    that.loading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        comfirm() {
            let that = this;
            if (that.dataList && that.dataList.length > 0) {
                that.loading = true;
                that.$util
                    .axiosPost({
                        url: '/api/EntpGoods/SaveGoodsLockSpaces',
                        data: {
                            GoodsId: that.GoodsId,
                            LockSpaces: that.dataList
                        },
                        hideLoading: true
                    })
                    .then(response => {
                        if (response.errcode == 0) {
                            that.$util.successMsg(response.errmsg);
                            that.$emit('closeDialog');
                        }
                    })
                    .catch(error => {
                        that.loading = false;
                    });
            } else that.$util.warningMsg('未检测到设置数据');
        },
        //仓位下拉框出现/隐藏时触发
        positionVisibleChange(val, warehouseId, warehouse) {
            if (!val) return;
            let that = this;
            if (!(warehouse.ShelfSpacesList && warehouse.ShelfSpacesList.length > 0)) {
                that.searchPositionReq.WarehouseId = warehouseId;
                that.searchPositionReq.ShelfSpaceCode = '';
                that.searchPositionReq.Page = 1;
                that.searchPosition(that.searchPositionReq).then(resp => {
                    let newArr = [];
                    if (resp.data) newArr = resp.data;
                    that.$set(warehouse, 'ShelfSpacesList', newArr);
                    that.loading = false;
                });
            }
        },
        remoteMethod(val, warehouseId, warehouse) {
            if (!val || !warehouseId) return;
            let that = this;
            that.searchPositionReq.WarehouseId = warehouseId;
            that.searchPositionReq.ShelfSpaceCode = val;
            that.searchPositionReq.Page = 1;
            that.searchPosition(that.searchPositionReq).then(resp => {
                let newArr = [];
                if (resp.data) newArr = resp.data;
                that.$set(warehouse, 'ShelfSpacesList', newArr);
                that.loading = false;
            });
        },
        searchPosition(req) {
            let that = this;
            if (!req.WarehouseId || that.loading) return;
            that.loading = true;
            return that.$util.GetStdShelfSpacesList(that.searchPositionReq);
        },
        positionChange(value, index) {
            let that = this;
            let data = { ...that.dataList[index] };
            data.SpacesIds = value;
            this.$set(this.dataList, index, data);
            this.$forceUpdate();
        }
    }
};
</script>
<style lang="less" scoped>
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}

.ops-ctn {
    text-align: left !important;
}

.dialog-header {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tips {
    color: #f00;
    margin-top: 4px;
    margin-left: 4px;
}

.dialog-footer {
    text-align: right;
}

.warehouseOut-main {
    padding: 10px 0;
}

.table-title {
    background: #f2f6fc;

    .div-table-cell {
        text-align: center;
        height: 36px;
        line-height: 36px;
    }
}

.div-table-row {
    position: relative;
    overflow: visible;
}

.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .cell-line {
        display: flex;
        width: 100%;
    }
}
</style>
